import VanillaScrollspy from './helpers/vanillajs-scrollspy';
import debounce from './helpers/debounce';
import { disableBodyScroll, enableBodyScroll } from './helpers/screenLock';

class Nav {
  constructor(nav) {
    this.nav = nav;
    this.menu = nav.querySelector('.js-nav-menu');
    this.button = nav.querySelector('.js-nav-button');
    this.items = [...nav.querySelectorAll('.js-nav-item')];
    this.isNavActive = false;

    this.scrollspy = new VanillaScrollspy({ menu: this.menu });

    this.handleResize = debounce(() => {
      if(window.innerWidth > 767) this.removeActiveClasses();
    }, 400);
  }

  init() {
    this.scrollspy.init();
    this.navBehaviorOnScroll();
    this.items[0].classList.add('active');

    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', () => this.navBehaviorOnScroll());
    this.button.addEventListener('click', () => this.toggleNav());
    this.items.map((item) => item.addEventListener('click', () => this.removeActiveClasses()));
  }

  toggleNav() {
    if(this.isNavActive) {
      this.nav.classList.remove('nav--active');
      enableBodyScroll(this.menu);
    } else {
      this.nav.classList.add('nav--active');
      disableBodyScroll(this.menu);
    }

    this.isNavActive = !this.isNavActive;
  }

  removeActiveClasses() {
    this.nav.classList.remove('nav--active');
    this.isNavActive = false;
    enableBodyScroll(this.menu);
  }

  navBehaviorOnScroll() {
    if (window.scrollY > 0) {
      this.nav.classList.add('nav--fixed');
    } else {
      this.nav.classList.remove('nav--fixed');
    }
  }
}

function navigation() {
  const navigation = document.querySelector('.js-nav');
  if (!navigation) {
    return
  }
  new Nav(navigation).init();
};

export default navigation;
